<div class="container mt-3 mx-auto">
    <div class="alert alert-info" *ngIf="!scrs || !scrs.length">
        Não foram encontrados arquivos SCR com os filtros informados.
    </div>

    <div *ngIf="scrs && scrs.length">

        <bn-paginacao [total]="atributosPaginacao.count" [tamanhoPagina]="atributosPaginacao.pageSize"
            [numPagina]="atributosPaginacao.page" [opcoesTamanhoPagina]="opcoesPaginacao" (aoMudar)="mudancaPagina($event)">

            <div class="table-responsive">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th id="col-id" scope="col">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'id'"
                                    [nomeAtributoExibicao]="'Id'" 
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>


                            <th id="col-data-base" scope="col">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'referencia'"
                                    [nomeAtributoExibicao]="'Data Base'" 
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>
                    
                            <th id="col-data-envio" scope="col">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'dataCriacao'"
                                    [nomeAtributoExibicao]="'Envio'" 
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>

                            <th id="col-nome-ativo" scope="col" class="moeda">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'ativo'"
                                    [nomeAtributoExibicao]="'Ativo'" 
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>
                                                       
                            <th id="col-usr-nome" scope="col">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'nomeUsuario'"
                                    [nomeAtributoExibicao]="'Nome Usuário Envio'" 
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>

                            <th scope="col">Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let scr of scrs">
                            <td>{{ scr.id  }}</td>
                            <!-- scr.referencia+'-01' e' porque o pipe date trabalha com valores yyyy-MM-dd, como estao vindo somente yyyy-MM, estou adicionando o dia como 01-->
                            <td>{{ scr.referencia+'-01'  | date: 'MM/yyyy'}}</td>
                            <td>{{ scr.dataCriacao | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
                            <td>{{ scr.ativo ? "Sim" : "Não" }}</td>
                            <td>{{ scr.nomeUsuarioEnvio }}</td>
                            <td>
                                <a href="javascript:void(0)" (click)="exportarAnexo(scr)" *ngIf="scr.nomeArquivo">
                                    <i class="fa fa-download cursor-pointer margin-left-5" placement="left-top" ngbTooltip="Exportar Anexo"></i></a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </bn-paginacao>
    </div>
</div>